(function () {
  const el = document.querySelector('.ai-box-panel');
  if (el) {
    const update = () => {
      document.documentElement.style.setProperty('--ai-box-total-height', el.offsetHeight + 'px');
    };
    const ro = new ResizeObserver(update);
    ro.observe(el);
    update();
  }

  const footer = document.querySelector('footer');
  const newsletter = document.querySelector('.newsletter') || footer;
  const buyBox = document.querySelector('buy-box-panel:not([data-temporary])');
  const surfaceStack = el?.closest('.product-surface-stack') || buyBox?.closest('.product-surface-stack');
  const boundaryAnchor = el || surfaceStack || buyBox;
  const panels = surfaceStack
    ? [surfaceStack]
    : [el, buyBox].filter(Boolean);

  if (footer && panels.length) {
    let frame = null;

    const updateFooterBoundary = () => {
      frame = null;
      const footerTop = footer.getBoundingClientRect().top;
      const bottomOffset = parseFloat(window.getComputedStyle(boundaryAnchor).bottom) || 0;
      const footerClearance = 40;
      const footerOffset = Math.max(
        0,
        window.innerHeight - bottomOffset + footerClearance - footerTop
      );

      panels.forEach((panel) => {
        panel.style.setProperty('--footer-bound-offset', `${footerOffset}px`);
      });
      const newsletterOffset = Math.max(
        0,
        window.innerHeight - bottomOffset + footerClearance - newsletter.getBoundingClientRect().top
      );
      const opacity = Math.max(0, 1 - newsletterOffset / 160);
      if (el) {
        el.style.setProperty('--ai-box-fixed-offset', `${footerOffset}px`);
        el.style.setProperty('--ai-box-boundary-opacity', `${opacity}`);
        el.toggleAttribute('data-newsletter-hidden', opacity === 0);
      }
      if (buyBox) {
        buyBox.style.setProperty('--buy-box-fixed-offset', `${surfaceStack ? 0 : footerOffset}px`);
        buyBox.style.setProperty('--buy-box-boundary-opacity', `${opacity}`);
        buyBox.toggleAttribute('data-newsletter-hidden', opacity === 0);
      }
    };

    const scheduleFooterBoundaryUpdate = () => {
      if (frame !== null) return;
      frame = window.requestAnimationFrame(updateFooterBoundary);
    };

    window.addEventListener('scroll', scheduleFooterBoundaryUpdate, { passive: true });
    window.addEventListener('resize', scheduleFooterBoundaryUpdate, { passive: true });
    new ResizeObserver(scheduleFooterBoundaryUpdate).observe(footer);
    if (newsletter !== footer) new ResizeObserver(scheduleFooterBoundaryUpdate).observe(newsletter);
    if (el) new ResizeObserver(scheduleFooterBoundaryUpdate).observe(el);
    document.querySelectorAll('buy-box-panel:not([data-temporary])').forEach((panel) => {
      new ResizeObserver(scheduleFooterBoundaryUpdate).observe(panel);
    });
    updateFooterBoundary();
  }

  // Homepage-only expanded hero behaviour.
  if (!el?.classList.contains('ai-box-panel--home')) return;

  const onScroll = () => {
    const expanded = window.scrollY <= 4;
    el.classList.toggle('is-hero', expanded);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
})();